export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9759d8d22cc6a3f62b5a70892dad6b16.jpg" 
          alt="Avoid Foreclosure in El Paso Texas" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="inline-flex items-center space-x-2 bg-red-600/90 text-white px-6 py-3 rounded-full mb-8">
          <i className="ri-alarm-warning-fill text-xl"></i>
          <span className="font-bold text-base">Stop Foreclosure Before It's Too Late</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
          Avoid Foreclosure Now<br />
          <span className="text-teal-400">We Buy Houses Fast in El Paso</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed">
          Facing foreclosure is overwhelming, but you have options. We buy foreclosed properties and homes at risk of foreclosure in El Paso, Texas. Get cash fast, avoid foreclosure damage to your credit, and move forward with peace of mind.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-12">
          <a 
            href="tel:+1-915-206-5814" 
            className="bg-teal-600 hover:bg-teal-700 text-white px-10 py-5 rounded-lg text-lg font-bold transition-all shadow-2xl cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 Now
          </a>
          <a 
            href="#how-we-help" 
            className="bg-white hover:bg-gray-100 text-gray-900 px-10 py-5 rounded-lg text-lg font-bold transition-all shadow-2xl cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
          >
            Learn How We Help
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl">
            <i className="ri-time-fill text-4xl text-teal-600 mb-3"></i>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Close in 7 Days</h3>
            <p className="text-sm text-gray-600">Fast cash offers to stop foreclosure quickly</p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl">
            <i className="ri-hand-coin-fill text-4xl text-teal-600 mb-3"></i>
            <h3 className="text-lg font-bold text-gray-900 mb-2">No Fees or Commissions</h3>
            <p className="text-sm text-gray-600">Keep more money in your pocket</p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl">
            <i className="ri-shield-check-fill text-4xl text-teal-600 mb-3"></i>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Avoid Credit Damage</h3>
            <p className="text-sm text-gray-600">Protect your financial future</p>
          </div>
        </div>
      </div>
    </section>
  );
}